/**
 * Web 前台业务限制统一配置。
 *
 * enabled 改为 true 表示开放对应功能；false 表示拦截并显示 message。
 * 这里只放前端展示和入口限制，真正的权限与业务校验仍由后端负责。
 */
const messages = {
  comingSoon: '敬请期待',
  comingSoonWithPunctuation: '敬请期待！',
  registrationClosed: '报名已结束，感谢关注。',
  longPressDeveloping: '长按保存功能开发中'
}

const webConfig = {
  messages,

  restrictions: {
    // 主 Layout 底部导航限制，对应 basicLayout.vue。
    bottomNavigation: {
      primary: {
        map: {
          enabled: true,
          message: messages.comingSoon,
          blockOnInitialSelection: false
        },
        userCenter: {
          enabled: true,
          message: messages.comingSoon,
          blockOnInitialSelection: true
        }
      },

      // 第二套 Layout 底部导航限制，对应 basicLayout2.vue。
      secondary: {
        map: {
          enabled: false,
          message: messages.comingSoon,
          blockOnInitialSelection: false
        }
      }
    },

    // 首页九宫格菜单限制，key 使用后台菜单名称。
    homeMenu: {
      '个人中心': { enabled: false, message: messages.comingSoon },
      '大会报名': { enabled: false, message: messages.comingSoon },
      '峰会直播': { enabled: false, message: messages.comingSoon }
    },

    // 后台菜单配置为这些占位链接时，不执行跳转。
    menuPlaceholderLinks: ['show-test'],

    // 日程、分会场配置为这些链接时，视为内容暂未开放。
    contentPlaceholderLinks: ['', 'show-test-none', 'show-test'],

    // 会议资料库开放限制。
    resourceLibrary: {
      openAt: '2025-09-11T09:00:00',
      checkInterval: 60 * 1000,
      longPressDelay: 800
    }
  }
}

export function getBottomNavigationRestriction(layout, key) {
  const restrictions = webConfig.restrictions.bottomNavigation[layout] || {}
  return restrictions[key] || null
}

export function getHomeMenuRestriction(name) {
  return webConfig.restrictions.homeMenu[name] || null
}

export function isMenuPlaceholderLink(link) {
  return webConfig.restrictions.menuPlaceholderLinks.includes(link)
}

export function isContentPlaceholderLink(link) {
  return webConfig.restrictions.contentPlaceholderLinks.includes(link || '')
}

export default webConfig
